function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Add New");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Header",
  transform: "translate(-773.000000, -40.000000)"
}, React.createElement("g", {
  id: "Group-16"
}, React.createElement("g", {
  id: "Add-from-above",
  transform: "translate(771.000000, 38.000000)"
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(2.000000, 2.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  stroke: "#215EFF",
  fill: "#215EFF",
  x: 0.5,
  y: 0.5,
  width: 25,
  height: 25,
  rx: 12.5
}), React.createElement("polygon", {
  id: "Shape",
  fill: "#FFFFFF",
  points: "12.1428571 7 12.1428571 12.1428571 7 12.1428571 7 13.8571429 12.1428571 13.8571429 12.1428571 19 13.8571429 19 13.8571429 13.8571429 19 13.8571429 19 12.1428571 13.8571429 12.1428571 13.8571429 7"
}))))));

const SvgHeaderAdd = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHeaderAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/header-add.20a449b7.svg";
export { ForwardRef as ReactComponent };